export default __webpack_public_path__ + "static/media/logoWithPic.62b076d8.svg";